import React, {
  Suspense,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { Link } from "react-router-dom";
import { getTrans as T } from "../../../../Shared/Language";
import { orgSettings } from "../../../../Services/Global-Services/GlobalServices";
import { Paginator } from "primereact/paginator";
import { Dropdown } from "primereact/dropdown";
import { TostMsg } from "../../../../App";
import { LazyImage } from "../../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding";
import {
  approveWfhStatus,
  getWFHDetails,
  rejectWFHStatus,
} from "./WfhSerevice";
import WfhNavBarItems from "./WfhCommon/WfhNavBarItems";
import WfhManagerReport from "./WfhCommon/WfhManagerReport";
import { getEmployeeList } from "../../EmployeeList/Service/employeeService";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import ERROR_LIST from "../../../../Services/Global-Services/Hadle_Errors";
const ComponentLoader = React.lazy(() =>
  import("../../../../Shared/Sidebar/ComponentLoader")
);

function TeamWfh() {
  const dispatch = useDispatch();
  const [wfhData, setWFHData] = useState([]);
  const toster = useContext(TostMsg);
  const [showAllUserDataModel, setshowAllUserDataModel] = useState([]);
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  const [resonValue, setResonValue] = useState("");
  const [Isloading, setIsloading] = useState(false);
  const [masterSystemAlertData, setMasterSystemAlertData] = useState([]);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [pageNumber, serPageNumber] = useState(1);
  const [pageSize, serPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [hierarchyValue, setHierarchyValue] = useState("2");
  const [selectedStatusValue, setselectedStatusValue] = useState("U");
  const [selectedEmployeId, setSelectedEmployeId] = useState(0);
  let Sdate = null;
  let EDate = null;
  const [filterStartDate, setFilterStartDate] = useState(Sdate);
  const [filterEndDate, setFilterEndDate] = useState(EDate);
  const [employeeList, setEmployeeList] = useState(null);
  const [showWfhHistory, setshowWfhHistory] = useState(null);
  const defaultImage = "/images/placeholder_profile.png";
  const [noData, setNoData] = useState([]);
  const ResontextStyle = {
    maxWidth: "100%",
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 3,
    overflow: "hidden",
    textOverflow: "ellipsis",
    cursor: "pointer",
  };
  const leaveRequestData = useSelector((state) => state.leave.leaveRequestData);

  useEffect(() => {
    GetMasterSystemAlertList("WFH_logged", 2);
    if (leaveRequestData) {
      OrgSettings(leaveRequestData);
      setSelectedEmployeId(leaveRequestData?.EmpId);
      setselectedStatusValue("P");
      setHierarchyValue("3");
      getEmployeeIdData(3);
      GetMasterSystemAlertList("Team_WFH_SubText", 1);
    } else {
      OrgSettings(null);
      getEmployeeIdData(0);
      GetMasterSystemAlertList("Team_WFH_SubText", 1);
    }
  }, []);

  useEffect(() => {
    if (selectedStatusValue && hierarchyValue) {
      getWFHData(pageNumber, pageSize);
    }
  }, []);

  const showFull = (id, expand) => {
    setWFHData((prev) =>
      prev.map((item) =>
        item.Id === id ? { ...item, showFull: expand } : item
      )
    );
  };

  const OrgSettings = useCallback(async (leaveRequestData) => {
    setIsloading(true);
    let param = {
      OrgId: userDetails?.OrgId,
    };
    try {
      let responce = await orgSettings(param);
      let StartDate = responce?.Data?.filter(
        (element) => element.KeyName == "LeaveFilterStartDate"
      );
      if (leaveRequestData) {
        Sdate = new Date(leaveRequestData?.StartDate)
          ?.toISOString()
          ?.split("T")[0];
        setFilterStartDate(Sdate);
        EDate = new Date(leaveRequestData?.EndDate)
          ?.toISOString()
          ?.split("T")[0];
        setFilterEndDate(EDate);
      } else {
        if (StartDate[0]?.Value != null) {
          Sdate = new Date(StartDate[0]?.Value)?.toISOString()?.split("T")[0];
        } else {
          Sdate = new Date(new Date() - 30 * 24 * 60 * 60 * 1000)
            ?.toISOString()
            ?.split("T")[0];
        }
        setFilterStartDate(Sdate);
        let EndDate = responce?.Data?.filter(
          (element) => element?.KeyName == "LeaveFilterEndDate"
        );
        if (EndDate[0]?.Value != null) {
          EDate = new Date(EndDate[0]?.Value)?.toISOString()?.split("T")[0];
        } else {
          EDate = new Date()?.toISOString()?.split("T")[0];
        }
        setFilterEndDate(EDate);
        if (Sdate && EDate) {
          getWFHData(pageNumber, pageSize);
        }
      }
    } catch (error) {
      Sdate = new Date(new Date() - 30 * 24 * 60 * 60 * 1000)
        ?.toISOString()
        ?.split("T")[0];
      EDate = new Date()?.toISOString()?.split("T")[0];
      setFilterStartDate(Sdate);
      setFilterEndDate(EDate);
      setIsloading(false);
    }
  }, []);

  async function getWFHData(pageNumber, pageSize) {
    setIsloading(true);
    const param = {
      OrgId: userDetails?.OrgId,
      LoggedInEmpId: userDetails?.EmpId,
      WFHid: 0,
      EmpId: selectedEmployeId,
      HierarchyTypeId: hierarchyValue,
      FilterStartDate: filterStartDate,
      FilterEndDate: filterEndDate,
      pageNumber: pageNumber,
      pageSize: pageSize,
      WFHcategory: selectedStatusValue,
    };
    try {
      const responce = await getWFHDetails(param);
      setIsloading(false);
      // setWFHData(responce?.Data);
      setWFHData(
        responce?.Data?.map((item) => ({
          ...item,
          showFull: false,
        }))
      );
      setTotalRecords(responce?.Data[0]?.TotalCount);
    } catch {
      setIsloading(false);
    }
  }

  //For get the employee data.
  const getEmployeeIdData = useCallback(async (HierarchyValue) => {
    setIsloading(true);
    var params = {
      OrganisationId: userDetails?.OrgId,
      LoggedInEmployeeId: userDetails?.EmpId,
      IsDirectReportOrHierarchy: Number(HierarchyValue),
      SearchText: "",
      FollowersOnly: 0,
      FollowingsOnly: 0,
      IsExEmployeesAlso: 0,
      IsSuggestedOnly: 0,
      pageNumber: 1,
      pageSize: 500000,
      EmployeeId: userDetails?.EmpId,
      IsSuggestedOnly: 0,
    };
    try {
      let employeesList = await getEmployeeList(params);
      let UpdatedemployeesList = employeesList?.Data?.toSpliced(0, 0, {
        id: 0,
        EmpId: 0,
        FullName: "All Employees",
      });
      setEmployeeList(UpdatedemployeesList);
      setIsloading(false);
    } catch (error) {
      setIsloading(false);
    }
  }, []);

  const handleResonChange = (e) => {
    setResonValue(e?.target?.value);
  };

  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage;
  }, []);

  const handleSubmit = async (submitType) => {
    if (submitType == "Approved") {
      setIsloading(true);
      const body = {
        id: showAllUserDataModel?.Id ?? 0,
        Reason: resonValue ?? "No Reson",
        RequestorId: showAllUserDataModel?.EmpId,
      };

      let awardList = await approveWfhStatus(body);
      if (awardList.StatusCode !== 2000) {
        setIsloading(false);
        document.querySelector("#pending-request .btn-close")?.click();
        toster.current.error(ERROR_LIST.DefaultError);
        return false;
      } else {
        setIsloading(false);
        document.querySelector("#pending-request .btn-close")?.click();
        GetMasterSystemAlertList("WFH_Approved", 0);
        setResonValue("");
        getWFHData(pageNumber, pageSize);
      }
    } else if (submitType == "Reject") {
      setIsloading(true);
      const body = {
        id: showAllUserDataModel?.Id ?? 0,
        Reason: resonValue ?? "No Reson",
        RequestorId: showAllUserDataModel?.EmpId,
      };

      let awardList = await rejectWFHStatus(body);
      if (awardList.StatusCode !== 2000) {
        setIsloading(false);
        document.querySelector("#pending-request .btn-close")?.click();
        toster.current.error(ERROR_LIST.DefaultError);

        return false;
      } else {
        setIsloading(false);
        document.querySelector("#pending-request .btn-close")?.click();
        setResonValue("");
        GetMasterSystemAlertList("WFH_Rejected", 0);
        getWFHData(pageNumber, pageSize);

      }
    }
  };

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == message && type == 1) {
        setMasterSystemAlertData(msg?.Desc);
      } else if (msg?.Name == message && type == 2) {
        setNoData(msg?.Desc);
      }
    });
  }, []);

  const onPageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
       serPageNumber(event.page + 1);  
       serPageSize(event.rows);  
    getWFHData(event.page + 1, event.rows);
  };

  const [HierarchyOptions] = useState([
    { value: "2", label: "Direct Report" },
    { value: "3", label: "Complete Hierarchy" },
  ]);

  const [WFHStatus] = useState([
    // { value: "", label: "All" },
    { value: "U", label: "Upcoming" },
    { value: "C", label: "Archived" },
    { value: "P", label: "Pending" },
  ]);
  const setSelectHierarchy = (event) => {
    getEmployeeIdData(event.target.value);
  };

  const employeeOptionTemplate = (option) => {
    return (
      <div className="flex align-items-center gap-2 ticket-file-attach__items_detail">
        <LazyImage
          alt={option?.FullName}
          src={option?.ProfileImage || defaultImage}
          onError={handleImageError}
          width="32"
        />
        <span>
          {option?.FullName}
          {option?.UserName?.length > 0 && ","}
        </span>
        <span>
          {option?.UserName}
          {option?.CurrentDesignation?.length > 0 && ","}
        </span>
        <span>{option?.CurrentDesignation}</span>
      </div>
    );
  };
  useEffect(() => {
    setTimeout(() => {
      getWFHData(pageNumber, pageSize);
    }, 500);
  }, [
    selectedEmployeId,
    selectedStatusValue,
    hierarchyValue,
    filterStartDate,
    filterEndDate,
  ]);

  const handleToggle = (index) => {
    if (showWfhHistory === index) {
      setshowWfhHistory(null);
    } else {
      setshowWfhHistory(index);
    }
  };
  return (
    <div>
      <div id="circular-menu" className="circular-menu">
        <a className="floating-btn">
          <i aria-hidden="true" className="fa fa-cog fa-spin"></i>
          <i aria-hidden="true" className="fa fa-times"></i>
        </a>
        <div className="items-wrapper">
          <div className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </div>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="languages-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </a>
          <Link to="" className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </Link>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="activity-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-grid"
            >
              <rect x="3" y="3" width="7" height="7"></rect>
              <rect x="14" y="3" width="7" height="7"></rect>
              <rect x="14" y="14" width="7" height="7"></rect>
              <rect x="3" y="14" width="7" height="7"></rect>
            </svg>
          </a>
        </div>
      </div>
      {/* <!-- row --> */}
      <div className="container-fluid position-relation">
        <div className="row g-3">
          <div className="form-head d-flex flex-wrap align-items-center">
            <div className="me-auto">
              <h2 className="font-w600 mb-0">{T("Team WFH's")}</h2>
              <p className="text-light">{masterSystemAlertData}</p>
            </div>
            <div className="rightside-tabs">
              <WfhNavBarItems />
            </div>
          </div>
          <div className="col-xl-8">
            <div className="leave-card tile-grid tile-grid-v1">
              <div className="tab-tabsa2">
                <div className="form-group d-gridcss mb-0">
                  <label>Start Date</label>
                  <input
                    type="date"
                    name="startDate"
                    onClick={(e) =>
                      e.target.showPicker && e.target.showPicker()
                    }
                    className="form-control"
                    placeholder="Start Date"
                    onFocus="(this.type='date')"
                    value={filterStartDate}
                    onChange={(e) => setFilterStartDate(e.target.value)}
                  />
                  <label>End Date</label>
                  <input
                    type="date"
                    name="endDate"
                    onClick={(e) =>
                      e.target.showPicker && e.target.showPicker()
                    }
                    className="form-control"
                    placeholder="End Date"
                    value={filterEndDate}
                    onChange={(e) => setFilterEndDate(e.target.value)}
                  />
                </div>
                <div className="widthdiv">
                  <Dropdown
                    value={selectedStatusValue}
                    onChange={(e) => setselectedStatusValue(e.target.value)}
                    options={WFHStatus}
                    optionLabel="label"
                    placeholder="Choose"
                    checkmark={true}
                    highlightOnSelect={false}
                  />
                </div>

                <div className="widthdiv">
                  <Dropdown
                    value={hierarchyValue}
                    onChange={(event) => {
                      setSelectHierarchy(event);
                      setHierarchyValue(event.target.value);
                    }}
                    options={HierarchyOptions}
                    optionLabel="label"
                    placeholder="Choose"
                    checkmark={true}
                    highlightOnSelect={false}
                  />
                </div>
                <div className="widthdiv">
                  <Dropdown
                    value={selectedEmployeId}
                    onChange={(e) => setSelectedEmployeId(e.target.value)}
                    options={employeeList}
                    filter={true}
                    optionLabel="FullName"
                    optionValue="EmpId"
                    itemTemplate={employeeOptionTemplate}
                    placeholder="Choose"
                    checkmark={true}
                    highlightOnSelect={false}
                  />
                </div>
              </div>
              {wfhData?.map((wfh, index) => {
                return (
                  <div key={index}>
                    <div className="leave-cards">
                      <div key={index}>
                        <div className="team-leavecard-list">
                          <div className="leave-container">
                            <img
                              src="/images/org-img/leave/upcoming1.png"
                              className="w-100  leave-image"
                            />
                            <div className="leave-count-overlay">
                              {wfh?.Days}
                            </div>
                          </div>
                          <div className="leave-body">
                            <div className="leave-type-row">
                              {/* <span class="leave-type unplanned"> {wfh?.WFHTypeName}</span> */}
                              <span className="emp-name">
                                <LazyImage
                                  className="avatar"
                                  src={wfh?.ProfileImage}
                                  data-demo-src="/images/avatar/1.jpg"
                                  alt=""
                                  data-user-popover="25"
                                  data-target="webuiPopover6"
                                  width="30px"
                                />{" "}
                                <p>{wfh?.EmployeeName}</p>
                              </span>
                            </div>
                            <p className="leave-description">
                              {wfh?.Reason?.length > 75 &&
                                !wfh?.showFull ? (
                                <>
                                  {wfh?.Reason.slice(0, 75)}...
                                  <span
                                    style={{
                                      color: "red",
                                      cursor: "pointer",
                                      fontSize: "12px",
                                    }}
                                    onClick={() => showFull(wfh.Id, true)}
                                  >
                                    read more
                                  </span>
                                </>
                              ) : (
                                wfh?.Reason
                              )}
                              {wfh?.showFull && (
                                <span
                                  style={{
                                    color: "red",
                                    cursor: "pointer",
                                    fontSize: "12px",
                                  }}
                                  onClick={() => showFull(wfh.Id, false)}
                                >
                                  &nbsp; read less
                                </span>
                              )}
                            </p>
                            <div className="leave-meta">
                              <div className="meta-item">
                                <span className="meta-label">From:</span>
                                <span className="meta-value">{moment(wfh?.StartDate).format("MMM DD YYYY")}</span>
                              </div>
                              <div className="meta-item">
                                <span className="meta-label">To:</span>
                                <span className="meta-value">{moment(wfh?.EndDate).format("MMM DD YYYY")}</span>
                              </div>
                              <div className="meta-item">
                                <span className="meta-label">Half Day:</span>
                                <span className="meta-value"> {wfh?.IsHalfDay == false && (
                                  <span>No</span>
                                )}{" "}
                                  {wfh?.IsHalfDay == true && <span>{wfh?.HalfPreference}</span>}</span>
                              </div>
                              <div className="innerdiv d-flex align-items-center ml-auto">
                                {wfh?.WFHStatusId === 103 && (
                                  <p
                                    className="Applied"
                                    // data-bs-toggle="modal"
                                    // data-bs-target="#pending-request"
                                    // onClick={() => {
                                    //   setshowAllUserDataModel(wfh);
                                    //   setResonValue("");
                                    // }}
                                  >
                                    <a>
                                      <i
                                        className="fa fa-clock-o"
                                        aria-hidden="true"
                                      ></i>{" "}
                                      {wfh?.WFHStatusName}
                                    </a>
                                  </p>
                                )}
                                {wfh?.WFHStatusId === 103 && (
                                  <a
                                    className="pending-status-btn-click btn"
                                    data-bs-toggle="modal"
                                    data-bs-target="#pending-request"
                                    onClick={() => {
                                      setshowAllUserDataModel(wfh);
                                      setResonValue("");
                                    }}
                                  >

                                    <i
                                      className="fa fa-clock-o"
                                      aria-hidden="true"
                                    ></i>{" "}
                                    Approve/Reject

                                  </a>
                                )}

                                <div className="innerdiv">
                                  {wfh?.WFHStatusId != 103 && (
                                    <a className="approved-status-btn">
                                      <i
                                        className="fa fa-clock-o"
                                        aria-hidden="true"
                                      ></i>{" "}
                                      {wfh?.WFHStatusName}
                                    </a>
                                  )}
                                </div>
                              </div>
                            </div>

                          </div>
                          <div
                            className="innerdiv show-more"
                            onClick={() => handleToggle(index)}
                          >
                            {showWfhHistory === index ? (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-chevron-down"
                                viewBox="0 0 16 16"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                                />
                              </svg>
                            ) : (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-chevron-up"
                                viewBox="0 0 16 16"
                              >
                                {" "}
                                <path
                                  fillRule="evenodd"
                                  d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z"
                                />
                              </svg>
                            )}
                          </div>
                        </div>
                        {showWfhHistory === index && (
                          <div className="my-leavedetail-view">
                            <div class="timeline-note">Leave Activity Timeline</div>
                            {wfh?.EmpWFHHistory?.length > 0 ? (
                              wfh?.EmpWFHHistory?.reverse()?.map(
                                (history, Hindex) => (
                                  <div key={history?.Id}>
                                    <ul className="timeline">
                                      <li className="timeline-inverted">
                                        <div className="timeline-badge">
                                          1
                                        </div>
                                        <div className="timeline-panel">
                                          <div className="flex-container flex-around">
                                            <div className="timeline-heading">
                                              <h4 className="timeline-title">
                                                {history?.ModifiedByName}
                                              </h4>
                                              {history?.LeaveStatusName === "Applied" && history?.Reason ? (
                                                <p className="timeline-title">{history.Reason}</p>
                                              ) : history?.Comments ? (
                                                <p className="timeline-title">{history.Comments}</p>
                                              ) : null}
                                              {/* {history?.CreatedBy === history?.ModifiedBy ? (
                                                history?.Reason?.length > 0 && (
                                                  <p className="timeline-title">
                                                    {history.Reason}
                                                  </p>
                                                )
                                              ) : (
                                                history?.Comments?.length > 0 && (
                                                  <p className="timeline-title">
                                                    {history.Comments}
                                                  </p>
                                                )
                                              )} */}
                                              <h5 className="leavestatus-timeline">
                                                <i
                                                  className="fa fa-clock-o"
                                                  aria-hidden="true"
                                                ></i>
                                                {history?.LeaveStatusName}
                                                <span>
                                                  on{" "}
                                                  {moment(
                                                    history?.ModifiedDate
                                                  ).format("MMM DD YYYY")}(
                                                  {new Date(
                                                    history?.ModifiedDate,
                                                  ).toLocaleTimeString([], {
                                                    hour: "numeric",
                                                    minute: "2-digit",
                                                  })}
                                                  )
                                                </span>
                                              </h5>
                                            </div>
                                            <div className="timeline-clock">
                                              <p>
                                                <i className="glyphicon glyphicon-time"></i>
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      </li>
                                    </ul>
                                  </div>
                                )
                              )
                            ) : (
                              <div>No WFH History Found.</div>
                            )}
                            <div className="remain-balance">
                              <div class="stat-card">
                                <div class="stat-label">Average leave</div>
                                <div class="stat-value">3</div>
                              </div>
                              <div class="stat-card">
                                <div class="stat-label">Recent leave</div>
                                <div class="stat-value">—</div>
                              </div>
                              <div class="stat-card">
                                <div class="stat-label">Leave balance</div>
                                <div class="stat-value balance">10</div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
              {wfhData?.length === 0 || wfhData?.length == null ? (
                <div className="no-data">
                  <img src="/images/no-data-found/Noworkfromhome.png" />
                  <p>{noData}</p>
                </div>
              ) : (
                <div className="card pagination-css">
                  <Paginator
                    first={first}
                    rows={rows}
                    totalRecords={totalRecords}
                    rowsPerPageOptions={[10, 20, 30]}
                    onPageChange={onPageChange}
                  />
                </div>
              )}
            </div>
          </div>
          <div className="col-xl-4">
            <div className="row sidecarddd">
              <div className="col-xl-12">
                <WfhManagerReport />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal fade" id="contact-manager">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title m-auto">
                Contact Your Reporting Manager htmlFor Any WFH Clarifications
              </h5>
            </div>
            <div className="modal-body text-center">
              <form>
                <div className="form-group text-left">
                  <label>Repoting Manager</label>
                  <select className="default-select form-control wide mb-3">
                    <option selected disabled>
                      Select reporting manager
                    </option>
                    <option>Arun Mishra</option>
                    <option>Pragya Tiwari</option>
                    <option>Alisha Goyal</option>
                  </select>
                </div>
                <div className="form-group text-left">
                  <label className="mt-3">Reason</label>
                  <textarea
                    rows="4"
                    cols="1"
                    className="form-control"
                  ></textarea>
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-danger light"
                data-bs-dismiss="modal"
              >
                Decline
              </button>
              <button type="button" className="btn btn-primary">
                Accept
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal fade" id="pending-request">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content pendingleaves">
            <div className="modal-header">
              <img
                src="/images/org-img/leave/popup-backimg.png"
                className="backimg"
              />
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
              <div className="img">
                <img src="/images/org-img/leave/pending.png" />
              </div>
            </div>



            <form onSubmit={handleSubmit}>
              <div className="modal-body text-center">
                <strong className="modal-title d-block">Pending Request</strong>
                <div className="inner">
                  <div className="h-avatar">
                    <LazyImage
                      className="avatar"
                      src={userDetails?.ProfileImage}
                      alt="Avatar"
                    />
                  </div>
                  <div className="para-detail">
                    <span className="name-p">
                      {showAllUserDataModel?.EmployeeName}
                    </span>
                    Applied
                    <span>
                      <b>From </b>-
                      {moment(showAllUserDataModel?.StartDate).format(
                        "MMM DD YYYY"
                      )}
                    </span>
                    <span>
                      <b>To </b>-
                      {moment(showAllUserDataModel?.EndDate).format(
                        "MMM DD YYYY"
                      )}
                    </span>
                    <span>
                      with
                      {showAllUserDataModel?.IsHalfDay == false && (
                        <span>no</span>
                      )}{" "}
                      {showAllUserDataModel?.IsHalfDay == true && (
                        <span>{showAllUserDataModel?.HalfPreference}</span>
                      )}
                      <b>Half Day </b>
                    </span>
                  </div>
                </div>

                <label className="mt-3">Reason</label>
                <textarea
                  rows="2"
                  cols="1"
                  className="form-control"
                  value={resonValue}
                  onChange={handleResonChange}
                ></textarea>
              </div>
            </form>



            <div className="modal-footer m-auto">
              <button
                type="button"
                className="cancelbtn-click"
                onClick={() => handleSubmit("Reject")}
              >
                Decline
              </button>
              <button
                type="button"
                onClick={() => handleSubmit("Approved")}
                className="savebtn-click"
              >
                Accept
              </button>
            </div>
          </div>
        </div>
      </div>{" "}
      {Isloading ? (
        <Suspense>
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </div>
  );
}

export default TeamWfh;
